// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"622":"7d6c7114","798":"3b2d9762","934":"8ae55ada"}[chunkId] + ".chunk.js";
};